var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star_10_",
    "data-name": "star (10)",
    transform: "translate(0 -0.09)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7123",
    "data-name": "Rectangle 7123",
    width: 15,
    height: 15,
    transform: "translate(0 0.09)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65012",
    "data-name": "Path 65012",
    d: "M30.561,33.546l3.054,1.844a.508.508,0,0,0,.763-.547l-.885-3.307a.487.487,0,0,1,.176-.507l2.739-2.172a.5.5,0,0,0-.291-.882l-3.575-.219a.5.5,0,0,1-.442-.311l-1.333-3.192a.512.512,0,0,0-.945,0l-1.333,3.192a.5.5,0,0,1-.442.311l-3.575.219a.5.5,0,0,0-.291.882l2.739,2.172a.487.487,0,0,1,.176.507L26.277,34.6a.606.606,0,0,0,.909.657l2.842-1.711A.519.519,0,0,1,30.561,33.546Z",
    transform: "translate(-22.539 -22.45)",
    fill: "#32496b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.90bd9661aa006ab7738229e0acc445b2.svg";
export { ForwardRef as ReactComponent };